module.exports = __webpack_public_path__ + "static/barak-hex-gray-d691c673b2d93c6e152f395e8fe65a4d.png";